import { Input } from '@trackman/web-shared-components';
import { ReactComponent as SearchIcon } from 'images/icons/Search.svg';
import { observer } from 'mobx-react-lite';

type Props = {
  label: string;
  input: string;
  onChange: (newValue: string) => void;
};

export const SearchForStudents = observer(({ label, input, onChange }: Props) => {
  return (
    <div className='search-for-students'>
      <label htmlFor='search-for-students'>{label}</label>
      <Input
        name='search-for-students'
        placeholder={'Search...'}
        value={input ?? ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.currentTarget.value)}
      />
      <SearchIcon />
    </div>
  );
});

export default SearchForStudents;
